module.exports = __webpack_public_path__ + "assets/img/DS-bathroom common (4).9f5dfaae.jpg";